import axios from 'axios';
import { from } from 'rxjs';

// The B2B session's organizations (backend multi-tenancy runbook Stage 4b):
// read fresh from Keycloak by the backend on every call. Never request the
// `organization` scope: the backend asks Keycloak itself.
const quiet = { skipCustomErrorHandling: true };
const api = () => `${globalConfig.api_URL}api/v2/private/organization`;

class OrganizationService {
    // [{ organizationId (UUID, null when not enrolled), name, alias, enrolled,
    //    primaryWorkspaceId, primaryWorkspaceExposedId (null until the init) }];
    //    [] for a validatege account. The website uses the exposed id.
    list = () => from(axios.get(api(), quiet));

    // the first switch into an enrolled organization: makes (201) or finds
    // (200) the caller's primary workspace -> { organizationId, workspaceId,
    // workspaceExposedId }
    init = (organizationId) => from(axios.post(`${api()}/${organizationId}/workspace`, null, quiet));

    // the organization whose primary workspace this is (by the workspace's
    // exposed id), or null
    ofWorkspace = (organizations, workspaceExposedId) =>
        (organizations || []).find(
            (o) => o.primaryWorkspaceExposedId != null && o.primaryWorkspaceExposedId === workspaceExposedId
        ) || null;
}

export default new OrganizationService();
